/**
 * Joins class names, dropping anything falsy.
 *
 * Forty bytes instead of a dependency. It exists so a component can write
 * `cx(base, active && activeClasses)` without `undefined` reaching the DOM as
 * the literal string "undefined", which is the failure this replaces.
 */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
